import {apiClient} from "../../../../lib/api-client";
import {MOParentRetailOrder} from "../types/MOParentRetailOrder";

export async function apiGetParentRetailOrder(retailOrderID: number): Promise<MOParentRetailOrder> {
	try {
		return await apiClient.get("material-order/parent-ro",
			{
				params: {
					retailOrderID: retailOrderID
				}
			});
	}
	catch (error: any) {
		console.log(error);
		return new Promise((resolve, reject) => { return reject(error); });
	}
};
